import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService, CustomHttp, ConfigServerService } from '../../../core';
import { Regiao } from '../regiao';
import { RegiaoFilter } from '../filter';
import { RegiaoSearchAsync } from '../regiao-search';

@Injectable({
    providedIn: 'root'
})
export class RegiaoCrudHttpService implements Crud<Regiao> {
    resource = 'regiao';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa todas as regiões cadastradas */
    search(): Observable<Regiao[]> {
        return this.crudService.search<Regiao>(this.resource);
    }

    /** Pesquisa as regiões utilizando o filtro */
    searchWithFilter(filter: RegiaoFilter, drawDatatable: number, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<RegiaoSearchAsync> {
        // Params
        let params = new HttpParams()
                            .append('drawDatatable', drawDatatable ? drawDatatable.toString() : null)
                            .append('offset', offset ? offset.toString() : null)
                            .append('limit', limit ? limit.toString() : null)
                            .append('orderBy', orderBy ? orderBy.toString() : null)
                            .append('orderByDir', orderByDir ? orderByDir : '');
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get(this.pathApi, {params});
    }

    /** Procura uma única região através do seu ID */
    find(id: number): Observable<Regiao> {
        return this.crudService.find<Regiao>(this.resource, id);
    }

    /** Carrega uma única região através do seu ID */
    load(id: number): Observable<Regiao> {
        return this.crudService.load<Regiao>(this.resource, id);
    }

    /** Insere uma nova região */
    insert(entity: Regiao): Observable<Regiao> {
        return this.crudService.insert<Regiao>(this.resource, entity);
    }

    /** Altera uma região existente */
    update(entity: Regiao): Observable<Regiao> {
        return this.crudService.update<Regiao>(this.resource, entity);
    }

    /** Exclui uma região através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
